import localForage from 'localforage'

import client, { authorizedCoreFetch, authorizedFetch, getAPIUrl } from '@/client';

export async function downloadStatistics({ query, labelName, artistName = '', releaseName = '', recordingName = '' }) {
  const { saveAs } = await import('save-as'); 

  //window.open(`${getAPIUrl()}/api/statistics.csv?${querystring}&access_token=${token}`, '_blank')
  //return
  /*authorizedCoreFetch('GET', `/statistics.csv`, {}, { ...query }).then( res => res.blob() )
  .then( blob => {
    //document.write(blob) 
    var file = new File([blob], `Statistics_${labelName}_${artistName}_${releaseName}_${recordingName}_${query.start}-${query.end}.csv`)
    const fileUrl = window.URL.createObjectURL(file); 
    saveAs(blob, `Statistics_${labelName}_${query.start}-${query.end}.csv`)
  });*/
  throw "Not implemented yet";
}

export async function downloadLeadListReport({ slug, query }) {
  const { saveAs } = await import('save-as');
  authorizedCoreFetch('GET', `/download/Leadlist_${slug}.xlsx`, {}, query).then( res => res.blob() )
  .then( blob => {
    saveAs(blob, `Leadlist_${slug}.xlsx`)
  }).catch(e => {
    console.error(e)
  });
}

export async function startImportProcess(slug) {
    // @ts-ignore
    const token = await localForage.getItem('token');
    var data = new FormData()
    const response = await fetch(
      `${getAPIUrl()}/importify/api/upload/${slug}/import`,
      {
        body: data,
        method: 'POST', 
        headers: {
          'Authorization': `Bearer ${token}`
        }
      }
    )
    if (!response.ok) {
      throw new Error("Failed to start import")
    }
    return await response.json()
}
